/**
 * Money is always represented as integer cents (BRL).
 * 850 cents = R$ 8,50
 */
export type Cents = number;

/**
 * Format cents as Brazilian Real for UI display.
 *   formatBrl(850) -> "R$ 8,50"
 *   formatBrl(0)   -> "R$ 0,00"
 */
export const formatBrl = (cents: Cents): string => {
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents);
  const reais = Math.floor(abs / 100).toString();
  const rest = (abs % 100).toString().padStart(2, '0');
  const reaisWithDots = reais.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${sign}R$ ${reaisWithDots},${rest}`;
};

/**
 * Parse a Brazilian formatted amount back to cents.
 * Accepts "R$ 8,50", "8,50", "8.50", "8" — returns null if unparseable.
 */
export const parseBrl = (raw: string): Cents | null => {
  const cleaned = raw.replace(/[^\d,.-]/g, '').trim();
  if (cleaned === '') return null;
  const normalized = cleaned.includes(',') ? cleaned.replace(/\./g, '').replace(',', '.') : cleaned;
  const value = Number.parseFloat(normalized);
  if (!Number.isFinite(value)) return null;
  return Math.round(value * 100);
};

/**
 * Junta "R$" e o número com espaço inseparável, para o valor não quebrar em
 * duas linhas na tela estreita (#595). Só para exibir: SMS, planilha e nota
 * fiscal seguem com o espaço comum de `formatBrl`.
 */
export const keepMoneyTogether = (text: string): string =>
  text.replace(/R\$ (?=-?\d)/g, 'R$\u00a0');
